
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import DimensionSelect from "../components/dimension-select.vue";
import TemplateView from "../components/template.vue";
import Dialog from "../components/delete-dialog.vue";
import Loading from "../../../components/loading.vue";

import Dimensions, {
  DimensionRes,
  Dimension
} from "../../../lib/dimension/dimension";
import { ExamV2Custom, Template, Vir } from "@/lib/model/exambuilder/exam-v2";
import { Post, PostList } from "@/lib/newExam/post";

import PositionList, {
  Industry,
  Position,
  PositionIndustryList,
  Template as TemplateNew
} from "@/lib/position/position";
@Component({
  components: { DimensionSelect, TemplateView, Dialog, Loading }
})
export default class SetDimension extends Vue {
  @Prop({ type: ExamV2Custom, default: null }) exam!: ExamV2Custom; //考试Model
  @Prop({ type: String, default: "" }) fromTemplateStoreId!: string; //模板库带入id
  @Prop({ default: false }) setWeb!: boolean; //内部使用 web配置
  @Prop({ type: PositionIndustryList, default: new PositionIndustryList() })
  positionIndustryList!: PositionIndustryList; //行业岗位list
  @Prop({ default: [new Vir()] }) virList!: Vir[]; //虚拟人list

  formData = {
    name: "",
    remark: "",
    classification: 0, // 面试类型 0:默认 1:集联面试（主面试） 2:题目包（子面试）
    questionIndustryId: 0, //默认0 通用
    questionPositionId: 0,
    virVersion: 0, // virVersion 虚拟视频版本  0:默认  1:TTS+讯飞形象版  2:TTS+IVH形象版  3:IVH版
    examScene: 0, //面试场景
    platformVersion: 0, //面试设备
    isRandomQuestions: 0 // 题目类型 1:随机抽题
  };
  rules = {
    name: [
      { required: true, message: "请输入面试名称", trigger: "change" }
      // { max: 12, message: "最多12个字符", trigger: "blur" }
    ],
    isRandomQuestions: [
      { required: true, message: "请选择面试模式", trigger: "change" }
    ]
  };
  dimensionList: Dimension[] = []; //已选维度全字段  冗余备用
  dimensionKeyList: string[] = []; //已选维度key
  templateList: ExamV2Custom[] = []; //模板list
  templateData = {}; //模板具体内容,融合的结构 先不写model
  templateDataList: any[] = [];
  templateShow = false;
  templateCheck = false;
  templateNameTem = ""; //二次确认 临时存下
  dataReady = false;
  jobs: Post[] = [];
  visibleChange(flag: boolean) {
    if (!flag) {
      // (this.$refs["form"] as any)?.validateField("positionId");
      // this.$nextTick(() => {
      //   this.onDataChange();
      // });
    } else if (!this.formData.questionIndustryId) {
      // 没有选择时默认展开第一个岗位分类
      const cascader = this.$refs.cascader as any;
      const panel = cascader?.$refs.panel;
      if (!panel) return;
      const node = panel.getNodeByValue([this.jobs[0].positionId]);
      panel.activePath = [node];
      panel.expandNodes([node]);
    }
  }

  // 获取岗位列表
  async getJobList() {
    const companyId = this.$route.query.companyId as string;
    const result = await PostList.get(companyId);
    this.jobs = result.positionGroups;
  }

  async created() {
    this.initData();
    if (this.setWeb) {
      this.getJobList();
    }
    this.dataReady = true;
  }
  mounted() {
    //
  }

  @Watch("exam")
  initData() {
    console.log(this.exam);
    this.formData.name = this.exam.name;
    this.formData.remark = this.exam.remark;
    this.dimensionKeyList = this.exam.dimensionKeyList;

    this.formData.classification = this.exam.classification;
    this.formData.questionIndustryId = this.exam.industryId;
    this.formData.questionPositionId = this.exam.positionId;
    this.formData.examScene = this.exam.examScene;
    this.formData.platformVersion = this.exam.platformVersion;
    this.formData.isRandomQuestions = this.exam.isRandomQuestions;
    //虚拟人版本
    if (this.exam.virVersion) {
      this.formData.virVersion = this.exam.virVersion;
    } else {
      const target = this.virList.find(item => item.isDefault === 1);
      if (target) {
        this.formData.virVersion = target.id;
      } else {
        this.formData.virVersion = this.virList?.[0]?.id;
      }

      this.exam.virVersion = this.formData.virVersion;
    }
  }

  //选择维度
  checkDimension(list: []) {
    console.log(list);
    this.dimensionList = list;
    this.exam.dimensionKeyList = [];
    for (const dim of this.dimensionList) {
      this.exam.dimensionKeyList.push(dim.dimensionKey);
    }
    this.change();
  }
  //离开前数据校验
  checkData() {
    let res = true;
    //表单
    (this.$refs["form"] as any)?.validate((valid: any) => {
      if (valid) {
        // alert("submit!");
      } else {
        res = false;
      }
    });
    //未选维度
    if (
      !this.exam.dimensionKeyList.length ||
      this.exam?.dimensionKeyList?.[0] === ""
    ) {
      (this.$refs.select as any)?.checkData();
      res = false;
    }
    //虚拟人版本有误
    if (
      this.virList.find((d, i) => {
        return d.id === this.exam.virVersion;
      })?.canUse !== 1
    ) {
      this.$message.error("请重新选择虚拟面试官形象");
      res = false;
    }
    return res;
  }

  onDataChange() {
    this.exam.name = this.formData.name;
    this.exam.remark = this.formData.remark;
    this.exam.industryId = this.formData.questionIndustryId;
    this.exam.positionId = this.formData.questionPositionId;
    this.exam.virVersion = this.formData.virVersion;
    this.exam.examScene = this.formData.examScene;
    this.exam.classification = this.formData.classification;
    this.exam.isRandomQuestions = this.formData.isRandomQuestions;
    console.log(this.exam.classification);
    this.exam.platformVersion = this.formData.platformVersion;
    this.change();
  }

  //岗位模板list 旧
  // async getTemplateList() {
  //   const t = await Template.get(Auth.companyId);
  //   if (t.data.code !== 0) return;
  //   this.templateList = new Template().assign(t.data).data; //model过滤
  //   this.templateDataList = t.data.data; //全量
  //   this.toCheckTemplateStoreId();
  // }

  //查看
  // showTemplate(name: string) {
  //   this.templateData = this.templateDataList.find(
  //     (d) => d.templateName === name
  //   );
  //   this.templateShow = true;
  // }
  //// 二次确认
  // checkTemplate(name: string) {
  //   if (this.exam.dimensionKeyList?.[0]) {
  //     this.templateNameTem = name;
  //     this.templateCheck = true;
  //   } else {
  //     this.selectTemplate(name);
  //   }
  // }

  // //选中模板
  // selectTemplate(name: string) {
  //   const t =
  //     this.templateList.find((d) => d.templateName === name) ||
  //     new ExamV2Custom();
  //   this.$emit("selectTemp", t);
  //   this.templateShow = false;
  //   this.$message.success("模板使用成功");
  // }
  // //模板库带入模板id 选中
  // toCheckTemplateStoreId() {
  //   if (this.fromTemplateStoreId) {
  //     const t = this.templateDataList.find((t) => {
  //       return String(t.templateId) === this.fromTemplateStoreId;
  //     });
  //     this.selectTemplate(t.templateName);
  //   }
  // }

  @Emit()
  change() {
    return;
  }
}
